import React, { useState, useEffect } from "react";
import {
  Button,
  Typography,
  Grid,
  Container,
  Box,
  Modal,
  TextField,
} from "@mui/material";
import axios from "axios";
import { getBlockchainNodeUrl } from "../globals/const";
import { storeWalletToDB } from "../globals/db";
import { WalletTokensTable } from "../components/WalletTokensTable";
import { isWalletDownloaded, setWalletDownloaded } from "../globals/utils";
import { useTranslation } from "react-i18next";
import { getWalletFromLocal } from "../globals/authentication";
import CustomAppBar from "../components/AppBar";

export default function WalletScreen({ walletType }) {
  const [wallet, setWallet] = useState({});
  const [walletVisible, setWalletVisible] = useState(false);
  const [showWalletDownloader, setShowWalletDownloader] = useState(false);
  const { t } = useTranslation();

  async function addWallet() {
    const res = await axios.get(
      getBlockchainNodeUrl() + "/generate-wallet-address"
    );
    const wallet = await res.data;
    console.log(wallet);
    storeWalletToDB(wallet);
    setWallet(wallet);
  }

  function download(filename, text) {
    var element = document.createElement("a");
    element.setAttribute(
      "href",
      "data:text/plain;charset=utf-8," + encodeURIComponent(text)
    );
    element.setAttribute("download", filename);

    element.style.display = "none";
    document.body.appendChild(element);

    element.click();

    document.body.removeChild(element);
    setWalletDownloaded(wallet["address"]);
    setShowWalletDownloader(false);
  }

  async function importWallet() {
    let walletJson = prompt("Enter wallet json: ");
    try {
      const wallet = JSON.parse(walletJson);
      if (!wallet) {
        throw "Empty wallet json";
      }
      storeWalletToDB(wallet);
      setWallet(wallet);
    } catch (e) {
      alert(e);
    }
  }

  const getWalletDetails = async () => {
    if (!wallet.address) return;
    const res = await axios.get(
      getBlockchainNodeUrl() + "/get-wallet?wallet_address=" + wallet.address
    );
    // const _walletDetails = await res.data;
    if (res.status === 200) {
      // setWalletDetails(_walletDetails);
    }
  };

  useEffect(() => {
    const loadWallet = async () => {
      const w = await getWalletFromLocal();
      setWallet(w);
    };

    loadWallet();
  }, []);

  useEffect(() => {
    getWalletDetails();

    async function decideWalletDownload() {
      if (!wallet["address"]) return;
      const walletDownloaded = await isWalletDownloaded(wallet["address"]);
      console.log("w", !walletDownloaded);
    }
    decideWalletDownload();
  }, [wallet]);

  return (
    <>
      <CustomAppBar />
      <Container maxWidth="xs">
        <div
          style={{
            padding: 0.25,
            paddingLeft: 0.5,
            paddingRight: 0.5,
            flexGrow: 1,
          }}
        >
          <Grid
            container
            justify="center"
            direction="column"
            style={{ marginTop: "10px" }}
          >
            {/* FundSelector */}
            <Grid container item>
              <Grid item xs>
                {wallet.address ? (
                  <>
                    {walletType === "DEFAULT" && (
                      <>
                        <Typography variant="subtitle1">
                          {t("Wallet Address")} :
                        </Typography>
                        <Grid container spacing={2}>
                          <Grid item xs>
                            <TextField
                              fullWidth
                              value={wallet.address}
                              size="small"
                              onFocus={(event) => {
                                event.target.select();
                              }}
                            />
                          </Grid>
                        </Grid>
                      </>
                    )}
                    <WalletTokensTable
                      walletAddress={wallet.address}
                      // setWalletBalancesParent={setWalletBalances}
                      walletType={walletType}
                    />

                    <Box>
                      {walletType === "FARMLAND" && (
                        <Button
                          onClick={() =>
                            (window.location.href = "/create-farmland")
                          }
                        >
                          {t("Add new Farmland")}
                        </Button>
                      )}
                      {walletType === "WAREHOUSELAND" && (
                        <Button
                          onClick={() =>
                            (window.location.href = "/create-warehouse-land")
                          }
                        >
                          {t("Add new Warehouse")}
                        </Button>
                      )}
                      {walletType === "PROCESSINGPLANTS" && (
                        <Button
                          onClick={() =>
                            (window.location.href = "/create-processing-plant")
                          }
                        >
                          {t("Add new Processing Plant")}
                        </Button>
                      )}
                      {walletType === "HARVEST" && (
                        <Button
                          onClick={() =>
                            (window.location.href = "/create-harvest")
                          }
                        >
                          {t("Create Harvest")}
                        </Button>
                      )}
                      {walletType === "CROP" && (
                        <Button
                          onClick={() =>
                            (window.location.href = "/create-crop")
                          }
                        >
                          {t("Create Crop")}
                        </Button>
                      )}
                      {walletType === "RECIPES" && (
                        <Button
                          onClick={() =>
                            (window.location.href = "/create-product-recipes")
                          }
                        >
                          {t("Create Product Recipe")}
                        </Button>
                      )}
                      {walletType === "BATCHES" && (
                        <Button
                          onClick={() =>
                            (window.location.href = "/create-batch")
                          }
                        >
                          {t("Create Batch")}
                        </Button>
                      )}
                      {walletType === "STORAGE" && (
                        <Button
                          onClick={() =>
                            (window.location.href = "/create-storage")
                          }
                        >
                          {t("Create Storage")}
                        </Button>
                      )}
                    </Box>
                  </>
                ) : (
                  <Box
                    sx={{
                      margin: "10px",
                      display: "flex",
                      justifyContent: "space-around",
                    }}
                    style={{ marginTop: "100px" }}
                  >
                    <Button
                      variant="contained"
                      onClick={addWallet}
                      color="primary"
                      style={{ marginRight: 10 }}
                    >
                      {t("Add Wallet")}
                    </Button>

                    <Button
                      variant="contained"
                      color="primary"
                      style={{ marginRight: 10 }}
                      onClick={importWallet}
                    >
                      {t("Import Wallet")}
                    </Button>
                  </Box>
                )}
              </Grid>
            </Grid>
          </Grid>
        </div>
        <Modal
          open={walletVisible}
          onClose={() => setWalletVisible(false)}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box
            sx={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              minWidth: 300,
              backgroundColor: "white",
              boxShadow: 24,
              padding: 10,
            }}
          >
            <TextField
              placeholder="Enter you transaction JSON"
              multiline
              rows={6}
              fullWidth
              maxRows={8}
              style={{ marginBottom: "10px" }}
              value={JSON.stringify(wallet)}
            />
          </Box>
        </Modal>
        <Modal
          open={showWalletDownloader}
          // onClose={() => setWalletVisible(false)}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box
            sx={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              minWidth: 300,
              backgroundColor: "white",
              // border: '2px solid #000',
              boxShadow: 24,
              padding: 10,
            }}
          >
            <Typography>
              {t(
                "It's important to download and store your wallet safely and securely. Losing the wallet can result in loss of funds and cannot be recovered by anyone."
              )}
            </Typography>
            <Button
              variant="contained"
              onClick={() => download("wallet.json", JSON.stringify(wallet))}
              size="small"
              color="primary"
              fullWidth
            >
              {t("Download")}
            </Button>
          </Box>
        </Modal>
      </Container>
    </>
  );
}
